<template>
  <StandardCardPageContainer>
    <h1 class="pt-2 pb-10">Welcome Super User!</h1>
    <div>
      <p>Please select a company you want to represent</p>

      <v-select
        class="mt-5"
        label="Select"
        :items="companies"
        item-title="name"
        v-model:model-value="selectedCompanyName"
      ></v-select>
      <PPrimaryButton @click="login" :loading="isLoading">Login</PPrimaryButton>
    </div>
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import { onBeforeMount, ref, type Ref, computed } from "vue";
import {
  getSuperUserCompanies,
  selectCompany,
} from "@/services/superUserService";
import type { SuperUserCompanyDto } from "@/models/dto/superUserCompanyDto";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { useUserProfileStore } from "@/stores/userProfileStore";
import { useTrustGroupStore } from "@/stores/trustGroup";
import { RouterPath } from "@/models/enum/routerPath";
import { useRouter } from "vue-router";
import { useSnackBarStore } from "@/stores/snackBarStore";

const isLoading = ref(false);
const router = useRouter();
const userProfileStore = useUserProfileStore();
const trustGroupStore = useTrustGroupStore();
const snackBarStore = useSnackBarStore();
const selectedCompanyName: Ref<string> = ref("");
const companies: Ref<Array<SuperUserCompanyDto>> = ref(
  new Array<SuperUserCompanyDto>()
);

onBeforeMount(async () => {
  fetchData();
});

const fetchData = async () => {
  try {
    isLoading.value = true;
    companies.value = await getSuperUserCompanies();
  } catch (error) {
    snackBarStore.showError();
  } finally {
    isLoading.value = false;
  }
};

const login = async () => {
  const selectedCompany = companies.value.find(
    (element) => element.name == selectedCompanyName.value
  );

  if (selectedCompany) {
    try {
      isLoading.value = true;
      await selectCompany(selectedCompany);

      await Promise.all([
        userProfileStore.setUserProfile(),
        trustGroupStore.setIsCustomer(),
        userProfileStore.setTrustGroup(),
      ]);
      router.push(RouterPath.Home);
    } catch (error) {
      snackBarStore.showError();
    } finally {
      isLoading.value = false;
    }
  }
};
</script>
